/*eslint-disable*/
import React from "react";

// reactstrap components
import { NavLink, Container } from "reactstrap";

// Core Components

function SiteFooter() {
  return (
    <>
      <footer className="footer footer-simple">
        <Container>
          <nav></nav>
          <div className="copyright text-right">
            © {new Date().getFullYear()}, Proudly Coded by{" "}
            <span className="text-primary">Tavon Petersen</span>.
          </div>
        </Container>
      </footer>
    </>
  );
}

export default SiteFooter;
